import { Component, ViewChild, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { UniStepperComponent } from "@universal-ui";
import { Subject } from "rxjs";

import { Unsubscriber } from "@shared/Components/Unsubscriber/unsubscriber.component";
import { NuevoUsuarioAdminCorporativo } from "@shared/Entities/AFI/Administracion/UsuarioCorporativo/nuevoUsuarioAdminCorporativo.entity";
import { Usuario } from "@shared/Entities/Usuario/usuario.entity";
import { UsuariosRepository } from "@shared/Repositories/usuarios.repository";

import { CanalesService } from "../../Shared/Services/canales.service";
import { Fideicomiso, NewUserAccessData, NewUserFiduciary, NewUserPersonalData } from "../../Shared/Types/new-user";

@Component({
  selector: "app-user-creation-fiduciary",
  templateUrl: "./user-creation-fiduciary.component.html",
  styleUrls: ["./user-creation-fiduciary.component.scss"],
})
export class UserCreationFiduciaryComponent extends Unsubscriber implements OnInit {
  public newUser: NewUserFiduciary | null = null;
  public nuevoAdministrador = new NuevoUsuarioAdminCorporativo();
  public resetForm: Subject<boolean> = new Subject();
  public currentUser: Usuario;
  public isOperative: boolean;
  public isUserCanales: boolean;

  @ViewChild("stepper") public stepper: UniStepperComponent;

  constructor(
    private readonly canalesService: CanalesService,
    private readonly router: Router,
    private readonly userRepository: UsuariosRepository
  ) {
    super();
  }

  public ngOnInit(): void {
    this.isOperative = this.router.url.includes("create-fiduciary-user-canales/operational");
    this.userRepository.getInfoClienteActual().subscribe((currentUser) => {
      this.currentUser = currentUser;
      this.isUserCanales = currentUser.usuarioRole.some((x) => x.role.nombre === "Canales Fiduciaria");
    });
  }

  public onSubmitPersonalData(personalData: NewUserPersonalData): void {
    this.newUser = { ...this.newUser, ...personalData };
  }

  public onSummit(fideicomisos: Fideicomiso): void {
    this.newUser = {
      ...this.newUser,
      escrows: fideicomisos,
      idAdminSelected: this.isUserCanales && this.isOperative ? fideicomisos[0].userId : this.currentUser.id,
    };

    this.anotherSubscription = this.canalesService.createNewUserFiduciary(this.newUser).subscribe((user) => {
      this.stepper.next();
      if (user.userCode) {
        this.newUser.userCode = user?.userCode || this.newUser?.userCode;
      }
    });
  }

  public onSubmitAccessData(accessData: NewUserAccessData): void {
    this.newUser = { ...this.newUser, ...accessData };
    this.stepper.next();
  }

  public onReset(): void {
    this.newUser = null;
    this.stepper.reset();
  }

  public onBack(): void {
    this.stepper.previous();
  }
}
